import PtzIcon from "../../../assets/ptz.svg";
import type { ProductGroup } from "../../../types";

export const ptz: ProductGroup = {
  id: "ptz",
  title: "ptz.title",
  icon: {
    src: PtzIcon,
    width: 45,
    height: 40,
  },
};
